import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import ProductCover from '../../shared/common/ProductCover';
import Utils from '../../shared/utils';
import { ProductMetaData } from '../../../models/Product';
import { mapLoanFormat } from '../../../models/LoanFormat';
import { useTranslation } from 'react-i18next';
import { MULTI_LANGUAGE_SHOP, useFeature } from '../../shared/utils/togglz';
import { useAgeCategorySearchParam } from '../../shared/utils/useAgeCategorySearchParam';

type Props = {
    readonly product?: ProductMetaData;
    readonly shopLanguage: string | undefined;
};

export const TitleOfTheMonthItem: FC<Props> = ({ product, shopLanguage }) => {
    const { t } = useTranslation();
    const isMultiLanguageShopEnabled = useFeature(MULTI_LANGUAGE_SHOP);
    const { searchParam: ageCategorySearchParam } = useAgeCategorySearchParam();

    if (!product || !product.id) {
        return null;
    }

    const firstAuthor = product.authors && product.authors.length > 0 ? product.authors[0] : undefined;

    return (
        <div className="title-of-the-month-container">
            <h2>{t('components.titleOfTheMonth')}</h2>
            <Link to={`/products/${product.id}`}>
                <ProductCover product={product} />
                <div className="product-title">{product.titleWithoutPrefix}</div>
            </Link>
            {firstAuthor ? (
                <Link
                    className="product-author"
                    to={Utils.catalogueLocationDescriptorString({
                        loanFormat: mapLoanFormat(product.loanFormat),
                        filter: { author: { include: [firstAuthor.id] } },
                        shopLanguage,
                        isMultiLanguageShopEnabled,
                        ageCategory: ageCategorySearchParam
                    })}
                >
                    <div className="product-author">
                        {firstAuthor.firstName} {firstAuthor.lastName}
                    </div>
                </Link>
            ) : null}
        </div>
    );
};
